import {createRouter, createWebHistory} from 'vue-router'
import LoginView from '../views/LoginView.vue'
import HomeView from "@/views/HomeView";
import DashboardView from "@/views/DashboardView";
import UserManageView from "@/views/manager/UserManageView";
import DifficultySettingView from "@/views/manager/DifficultySettingView";
import MaterialEditorView from "@/views/MaterialEditorView.vue";
import MaterialDetailView from "@/views/material/MaterialDetailView.vue";
import EnumValueListView from "@/views/manager/EnumValueListView.vue";
import XhsListView from "@/views/xhs/XhsListView.vue";
import XhsScriptView from "@/views/xhs/XhsScriptView.vue";
import PcSiteView from "@/views/site/PcSiteView.vue";
import SiteSpyView from "@/views/spy/SiteSpyView.vue";
import CommonHtmlEditorView from "@/views/site/CommonHtmlEditorView.vue";
import CommonHtmlPreviewView from "@/views/site/CommonHtmlPreviewView.vue";
import SiteConfigView from "@/views/site/SiteConfigView.vue";

const routes = [
    {
        path: "/",
        name: "home",
        component: HomeView,
        redirect: "/dashboard/0",
        children: [
            {
                path: "/dashboard/:boomType",
                component: DashboardView
            },
            {
                path: "/editor/:materialId",
                component: MaterialEditorView
            },
            {
                path: "/user/list",
                component: UserManageView
            },
            {
                path: "/material/detail/:materialId",
                component: MaterialDetailView
            },
            {
                path: "/difficulty/setting",
                component: DifficultySettingView
            }, {
                path: '/enum/list/:type',
                component: EnumValueListView
            }, {
                path: '/xhs/list',
                component: XhsListView
            },{
                path: '/pc/site/:tab',
                component: PcSiteView,
            },{
                path: '/site/spy',
                component: SiteSpyView
            },{
                path: '/site/config/:siteId',
                component: SiteConfigView
            },
        ],
        meta: {
            auth: true
        }
    },
    {
        path: '/html/edit/:htmlId',
        component: CommonHtmlEditorView
    },
    {
        path: '/html/preview/:htmlId',
        component: CommonHtmlPreviewView
    },
    {
        path: '/xhs/script',
        name: 'XhsScriptView',
        component: XhsScriptView,
        meta: {
            auth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
        meta: {
            auth: false
        }
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
